import * as React from 'react';
import { Filter } from './search_filters';
import RegionFilterOptions, { PlaceholderSelect } from './region_filter_options';
import bind from '../bind';

interface IProps {
  filter: Filter; // filter with selected region only
}

interface IState {
  showFullFilter: boolean;
}

export default class RegionSelectFilter extends React.Component<IProps, IState> {
  state = {
    showFullFilter: false,
  };

  @bind
  handleClick() {
    this.setState({
      showFullFilter: true,
    });
  }

  renderFilterOptions() {
    if (!this.state.showFullFilter) {
      return (
        <PlaceholderSelect
          onClick={this.handleClick}
          name={this.props.filter.options[0].name}
          loading={false}
        />
      );
    }

    return (
      <RegionFilterOptions placeholderFilter={this.props.filter} />
    );
  }

  render() {
    return (
      <div className="facet">
        <div className="facet__heading">
          {this.props.filter.name}
        </div>
        {this.renderFilterOptions()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/region_select_filter.tsx